import {Component, Inject, ElementRef, ViewChild, OnInit, Input} from '@angular/core';
import {Config} from './config';
import { MapService } from './map-view/map.service';
import { EventsService } from './EventsService';
import { EsriTasksService } from './esriTasks/esriTasks-service';
import PrintTask = require('esri/tasks/PrintTask');
import PrintTemplate = require('esri/tasks/support/PrintTemplate');
import PrintParameters = require('esri/tasks/support/PrintParameters');
import Print = require('esri/widgets/Print');
import EsriRequest = require('esri/request');
import {Http, Headers, RequestOptions, Jsonp} from '@angular/http';
import Point = require('esri/geometry/Point');

@Component({
    selector: 'main-app',
    template: require('./app.component.html'),
    styles: [require('./app.component.css')]
})

export class AppComponent {
    logoPath:string = "./images/DMD-logo.png";
    mapUpdateShow:boolean = false;

    appMainViewImgPath:string = "./images/MainViewScreenShot.png";
    private showAddressComponent:boolean = true;
    private showSearchTool:boolean = true;
    private initialModuleSelected:boolean = false;
    loadingImagePath:string = "./images/loading.gif";

    appSettings: Object = null;
    searchModules:Array<any> = [];
    showSearchOptions:boolean = false;

    hideTitle:boolean = true;

    urlSearchObject:string = "";

    localStorage:any = window.localStorage;
    @ViewChild('tabBar') tabBar:ElementRef;

    @ViewChild('shortUrlId') shortUrlId:ElementRef

    printWidget:Print = null;
    showPrint:boolean = false;

    private operationalLayersCount:number = 0;

    showEmailPanel:boolean = false;
    emailSubject:string = "";
    emailBody:string = "";
    linkGenerationInProgress:boolean = false;

    showAppHelp:boolean = false;

    showObliqueImage:boolean = false;

    tabsDisabled:boolean = false;
    showCopyShortURL:boolean = false;
    shortUrlCopied:boolean = false;
    shortUrlValue:string = "";
    showParcelReportComponent:boolean = false;

    private iOS:boolean = false;

    constructor(private elRef:ElementRef, private _mapService:MapService, private _eventsService:EventsService, private _esriTasksService:EsriTasksService, private http:Http, private jsonp:Jsonp){
        // console.log(this.document.location.href);
        // console.log(window.location.origin);
        var search:string = decodeURI(window.location.search).substr(1);
        this.urlSearchObject = search.split('=')[1];
        console.log(this.urlSearchObject);
    }

    ngOnInit(){
        this._eventsService.addressSearchActivate$.subscribe(show =>
            this.showAddressComponent = (show as boolean)
        );
        this._eventsService.searchToolShow$.subscribe(show =>
            {
                this.showSearchTool = (show as boolean);
                this.initialModuleSelected = true;
            } 
        );
        this._eventsService.mapUpdateShow$.subscribe(show => {
            this.mapUpdateShow = show;
        });


        this.appSettings = Config.config[0];
        this.emailSubject = this.appSettings["EmailService"]["subject"];
        this.searchModules = this.appSettings["SearchModules"];
        this._eventsService.dynamicLayerViewCreated$.subscribe(show => 
            {
                this.operationalLayersCount++;
                if(this.appSettings["Map"]["Layers"]["OperationalLayers"].length == this.operationalLayersCount){
                    this.showSearchOptions = true
                }
            }
        )

        // var tab = document.createElement('a');
        // tab.className = "mdl-layout__tab";
        // tab.innerHTML = "Test Tab";
        // tab.setAttribute("href", "#tabMap");
        // var tabBar = document.getElementById("tabBar")
        // tabBar.appendChild(tab);

        this._eventsService.moduleSelect$.subscribe(module => {
            //this.moduleSelected(module);
        });

        this._eventsService.expandMenuToolbar$.subscribe(expand => {
            this.hideTitle = expand;
        });

        // this._eventsService.showObliqueImage$.subscribe(show => {
        //     this.showObliqueImage = show;
        // });

        this._eventsService.searchToolShow$.subscribe(evt => {
            this.tabsDisabled = evt;
        });

        // /***TEST PolygonAnalysis service***/
        // var url:string = this.appSettings["ParcelReport"]["TextValuesPage1"]["url"];
        // var layersArray:Array<any> = this.appSettings["ParcelReport"]["TextValuesPage1"]["layers"];
        // this._esriTasksService.soePolygonAnalysis(url, null, layersArray);

        this.iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    }

    moduleSelected(module:any){
        // var tabs:HTMLCollection = this.tabBar.nativeElement.children;
        // for (var i:number = 0; i < tabs.length; i++){
        //     if((module["Name"] as string).toLowerCase() == (tabs[i]["innerText"] as string).toLowerCase()){
        //         tabs[i].classList.add('is-active');
        //     }else{
        //         tabs[i].classList.remove('is-active');
        //     }
        // }
    }

    tabClicked(event:any){
        if(event["event"].currentTarget.classList.contains('is-active')){
            return;
        }
        this._eventsService.moduleSelect(event["module"]);
    }

    saveSelection(){
        //window.localStorage.setItem("PlanIndy_saved_search", JSON.stringify({}));
        this._eventsService.startSaveSearch();
    }
    
    getLastSavedSearch(){
        var savedSearch = JSON.parse(window.localStorage.getItem("PlanIndy_saved_search"));
        if(savedSearch["geometry"] != null){
            var geometryObject:Object = {};
            geometryObject["geometry"] = savedSearch["geometry"];
            geometryObject["buffer"] = savedSearch["buffer"];
            geometryObject["showOnlyWithinGeometry"] = savedSearch["showOnlyWithinGeometry"];
            this._eventsService.setSavedGeometry(geometryObject);
        }
        this._eventsService.savedSearchSelect(savedSearch["module"]);
        this._mapService.view.extent = savedSearch["extent"];
    }

    hidePrintWidget(){
        this.showPrint = false;
    }

    printMap(){
        this.showPrint = true;
        if(this.printWidget == null){
            this.printWidget = new Print({
                view: this._mapService.view,
                printServiceUrl: this.appSettings["Printing"]["serviceURL"],
                container: "PrintWidgetDiv"
            });
        }
    }

    copyToBuffer(){
        this.linkGenerationInProgress = true;
        this._eventsService.createAppURL("copy");
    }

    createSMS(){
        this.linkGenerationInProgress = true;
        this._eventsService.createAppURL("sms");
    }

    createEmail(){
        this.linkGenerationInProgress = true;
        this._eventsService.createAppURL("email");
    }


    createShortUrl(shareString:string){
        var shareObject:any = JSON.parse(shareString);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let msgBody:Object = {"queryString": shareObject.url};
        this.http.post(this.appSettings["URLShortener"]["createQueryURL"], msgBody, options).toPromise().then((response)=>{
            var queryID:string = response.json();
            var queryURL:string = window.location.href.split('?')[0] + "?queryid=" + queryID;
            console.log(queryURL);
            switch(shareObject.method){
                case "sms": 
                    window.location.href = "sms:&body=" + queryURL;
                    break;
                case "email":
                    this.emailBody = queryURL;
                    this.showEmailPanel = true;
                    break;
                case "copy":
                    try{
                        this.showCopyShortURL = true;
                        this.shortUrlCopied = false;
                        this.shortUrlValue = queryURL;
                        // // Create an auxiliary hidden input
                        // var aux = document.createElement("input");
                        // // Get the text from the element passed into the input
                        // aux.setAttribute("value", queryURL);
                        // // Append the aux input to the body
                        // document.body.appendChild(aux);
                        // // Highlight the content
                        // aux.select();
                        // // Execute the copy command
                        // document.execCommand("copy");
                        // // Remove the input from the body
                        // document.body.removeChild(aux);
                    }catch(ex){
                        console.log(ex);
                        this.showCopyShortURL = false;
                        this.shortUrlCopied = false;
                    }
            }
            this.linkGenerationInProgress = false;
        }).catch(e=>{
            console.log(e);
            alert("Operation failed. Please try again later.");
            this.showCopyShortURL = false;
            this.shortUrlCopied = false;
            this.linkGenerationInProgress = false;
        });
        
        // this.http.post("https://www.googleapis.com/urlshortener/v1/url?key=AIzaSyDby2eRAyjDldk2AOfgBi5zvipxiftG4W4", msgBody, options).toPromise().then((response)=>{
        //     var responseObject:Object = response.json();
        //     var tinyUrl:string = responseObject["id"];
        //     switch(shareObject.method){
        //         case "sms": 
        //             window.location.href = "sms:&body=" + tinyUrl;
        //             break;
        //         case "email":
        //             this.emailBody = tinyUrl;
        //             this.showEmailPanel = true;
        //             break;
        //     }
        // }).catch(e=>{console.log(e)})
    }

    fullExtent(){
        this._mapService.view.zoom = 4;
        //map is loaded, then do some stuff
        var pt:Point = new Point({
            x: this.appSettings["Map"]["Center"]["x"],
            y: this.appSettings["Map"]["Center"]["y"],
            spatialReference: this._mapService.view.spatialReference
        });
        this._mapService.view.center = pt;
    }

    copyToClipboard(){
        try{
            this.shortUrlId.nativeElement.select();
            document.execCommand("copy");
            this.shortUrlCopied = true;
        }
        catch(ex)
        {
            alert("Could not copy. Please select the text and copy it manually.");
        }
    }

    closeCopyToClipboard(){
        this.showCopyShortURL = false;
        this.shortUrlCopied = false;
    }

    addressLocationPicked(pickedAddressLocation:object){
        this._eventsService.changeNav(pickedAddressLocation);
    }
}


// WEBPACK FOOTER //
// ./app/app.component.ts